import airbnb1 from "../img/airbnb1.jfif";
import airbnb2 from "../img/airbnb2.jfif";
import weather1 from "../img/weather1.jfif";
import weather2 from "../img/weather2.jfif";
import drep1 from "../img/drep1.JPG";
import drep2 from "../img/drep2.jfif";
import destin1 from "../img/destin1.jpg";
import destin2 from "../img/destin2.jpg";
import mazuma1 from "../img/mazuma1.jpg";
import mazuma2 from "../img/mazuma2.jpg";
import automate from "../img/automate.JPG";
import automate2 from "../img/automate-2.JPG";

const projectData = () => {
  return [
    {
      name: "Airbnb Clone",
      desc: "An Airbnb clone website built using the MEN Stack as a final project with full CRUD functionality and a working login system.",
      img1: airbnb1,
      img2: airbnb2,
      link: "https://github.com/VishnuRupan/airbnb-clone",
      linkName: "Github",

      index: 0,
    },

    {
      name: "React Weather App",
      desc: "Simple Weather App built using React, Axios and free Weather API. Background image changes depending on the current weather status.",
      img1: weather1,
      img2: weather2,
      link: "https://trusting-jepsen-074adb.netlify.app/",
      linkName: "Link",
      index: 1,
    },

    {
      name: "Hackathon Project - DREP",
      desc: "Solving the issue of contactless payments by receiving digital receipts using QR codes. Runner up in Seneca’s COVID-19 Business Response Hackathon.",
      img1: drep1,
      img2: drep2,
      link: "https://github.com/nsmseifi/HACKATHON-P6",
      linkName: "Github",

      index: 2,
    },

    {
      name: "Mazuma - Tangerine React Redesign",
      desc: "Front-end design of a reimagined Tangerine page. Design decisions strayed from the norm while retaining relevant info. Includes a second submenu Navbar and unique mobile menu toggle.",
      img1: mazuma1,
      img2: mazuma2,
      link: "https://quizzical-euler-574159.netlify.app/",
      linkName: "Link",

      index: 3,
    },

    {
      name: "Canada Job Bank Automation",
      desc: "Automated job application script built with python. Created for a friend, this script will email employers your resume and record application details on an Excel spreadsheet.",
      img1: automate,
      img2: automate2,
      link: "https://github.com/VishnuRupan/job-search-automation",
      linkName: "Link",

      index: 3,
    },

    {
      name: "Capture - React Front-End",
      desc: "Front-end sample portfolio website built using React with custom animations and page transitions.",
      img1: destin1,
      img2: destin2,
      link: "https://epic-volhard-efcbea.netlify.app/",
      linkName: "Link",

      index: 5,
    },
  ];
};

export default projectData;
